module.exports = __webpack_public_path__ + "althash-health/static/img/help_userread_1.4216def.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help_userread_1.png
// module id = Aaxy
// module chunks = 1